import { Check, Crown } from "lucide-react";
import { MEMBERSHIPS, buildWhatsAppLink } from "@/data/lakaData";

const Memberships = () => (
  <section
    id="membresias"
    data-testid="memberships-section"
    className="py-24 md:py-32"
    style={{ background: "#E8DFD1" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="text-center mb-14">
        <span className="laka-eyebrow">LAKA Club Beauty Membership</span>
        <h2 className="mt-4 font-serif-laka text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-[#1A1A1A] max-w-3xl mx-auto">
          Un club para cuidarte <span className="italic text-[#D6B36A]">todo el año</span>
        </h2>
        <p className="mt-5 text-sm md:text-base text-[#1A1A1A]/70 max-w-xl mx-auto leading-relaxed font-light">
          Planes mensuales pensados para acompañar tu ritmo beauty con beneficios
          exclusivos, prioridad y ventajas continuas.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-8">
        {MEMBERSHIPS.map((m) => {
          const wa = buildWhatsAppLink(
            `Hola LAKA, me interesa la membresía ${m.name} (${m.price}€/mes). Quiero más información.`,
          );
          return (
            <div
              key={m.key}
              data-testid={`membership-${m.key}`}
              className={`relative p-8 md:p-10 flex flex-col transition-all duration-500 ${
                m.highlighted
                  ? "bg-[#1A1A1A] text-[#FBF6F2] -translate-y-2 shadow-[0_40px_80px_-30px_rgba(26,26,26,0.35)]"
                  : "bg-[#FBF6F2] text-[#1A1A1A] laka-card"
              }`}
            >
              {m.highlighted && (
                <div className="absolute top-4 right-4 flex items-center gap-1.5 text-[#D6B36A] text-[0.6rem] tracking-[0.3em] uppercase font-medium">
                  <Crown className="w-3.5 h-3.5" strokeWidth={1.5} />
                  Popular
                </div>
              )}
              <div
                className={`text-[0.62rem] tracking-[0.3em] uppercase font-medium ${
                  m.highlighted ? "text-[#D6B36A]" : "text-[#D6B36A]"
                }`}
              >
                {m.tagline}
              </div>
              <h3 className="mt-3 font-serif-laka text-4xl">{m.name}</h3>
              <div className="mt-6 font-serif-laka">
                <span className="text-6xl">{m.price}€</span>
                <span
                  className={`ml-2 text-sm ${
                    m.highlighted ? "text-[#FBF6F2]/60" : "text-[#1A1A1A]/50"
                  } font-sans-laka`}
                >
                  / mes
                </span>
              </div>
              <div
                className={`my-8 h-px ${
                  m.highlighted ? "bg-[#FBF6F2]/20" : "bg-[#1A1A1A]/10"
                }`}
              />
              <ul className="space-y-3 flex-1">
                {m.benefits.map((b) => (
                  <li key={b} className="flex items-start gap-3 text-sm">
                    <Check
                      className={`w-4 h-4 mt-0.5 shrink-0 ${
                        m.highlighted ? "text-[#D6B36A]" : "text-[#D6B36A]"
                      }`}
                      strokeWidth={1.6}
                    />
                    <span
                      className={
                        m.highlighted ? "text-[#FBF6F2]/85" : "text-[#1A1A1A]/75"
                      }
                    >
                      {b}
                    </span>
                  </li>
                ))}
              </ul>
              <a
                data-testid={`membership-cta-${m.key}`}
                href={wa}
                target="_blank"
                rel="noreferrer"
                className={`mt-10 laka-btn-primary w-full ${
                  m.highlighted ? "laka-btn-gold" : ""
                }`}
              >
                Quiero ser miembro
              </a>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default Memberships;
